/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMemo } from 'react';
import { useParams, useLocation, useHistory, useRouteMatch, matchPath } from 'react-router-dom';
import qs from 'qs';
import { pathOr } from 'ramda';
import { To } from 'history';

type UseRouterType = {
  push: (to: To, state?: Record<string, unknown>) => void;
  replace: (to: To, state?: Record<string, unknown>) => void;
  pathname: string;
  match: typeof useRouteMatch;
  matchPath: typeof matchPath;
  location: any;
  history: any;
  getUrlParam: (param: string) => string | null;
};

const useRouter = (): UseRouterType => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch;

  const getUrlParam = (param: string) => {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true });

    return pathOr(null, [param], search);
  };

  return useMemo(() => {
    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      match,
      matchPath,
      location,
      history,
      getUrlParam,
    };
  }, [params, match, location, history]);
};

export default useRouter;
